import React from 'react';
import styles from './styles.module.less';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const ORDER_TYPES = {
  ASC: 'asc',
  DESC: 'desc',
};

/**
 *
 * @param {string} column - The column to sort
 * @param {function} onChange - The function to call when the sort changes
 * @param {array} defaultValues - The default values to use for the sort
 * @returns {React.Component} The SorterColumn component
 */
const SorterColumn = ({
  column,
  onChange,
  defaultValues,
  upIcon = 'arrow_upward',
  downIcon = 'arrow_downward',
}) => {
  const defaultOrder = React.useMemo(() => {
    return defaultValues.reduce((acc, el) => {
      const key = el.name;
      const value = {
        order: el.order,
      };
      acc[key] = value;
      return acc;
    }, {});
  }, [defaultValues]);

  const [activeOrder, setActiveOrder] = React.useState(defaultOrder);

  React.useEffect(() => {
    setActiveOrder(defaultOrder);
  }, [defaultOrder]);

  const handleSortClick = React.useCallback(
    (e, order) => {
      e.preventDefault();
      e.stopPropagation();

      const currentOrder = activeOrder?.[column]?.order;
      const sortFields = {};

      if (currentOrder === order) {
        sortFields[column] = {
          order: null,
        };
      } else {
        sortFields[column] = {
          order,
        };
      }

      setActiveOrder(sortFields);

      if (onChange) {
        onChange(sortFields);
      }
    },
    [column, activeOrder, onChange],
  );

  return (
    <span className={styles.sortIcons + ' gx-pointer'}>
      <i
        className={classNames(
          'material-icons',
          activeOrder?.[column]?.order === ORDER_TYPES.ASC && styles.active,
        )}
        onClick={e => handleSortClick(e, ORDER_TYPES.ASC)}
      >
        {upIcon}
      </i>
      <i
        className={classNames(
          'material-icons',
          activeOrder?.[column]?.order === ORDER_TYPES.DESC && styles.active,
        )}
        onClick={e => handleSortClick(e, ORDER_TYPES.DESC)}
      >
        {downIcon}
      </i>
    </span>
  );
};

SorterColumn.propTypes = {
  column: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultValues: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      order: PropTypes.oneOf([ORDER_TYPES.ASC, ORDER_TYPES.DESC, null]),
    }),
  ),
};
export default SorterColumn;
